import { useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";

import { toggleMarkAsUnsuitableReasonModal } from "@/reducers/clientcommon";
import { toastMessageText } from "@/utilities/CommonText";
import { showCommonToast } from "@/utilities/utils";

export const MarkAsUnsuitableButton = ({
  selectedCandidate = [],
  loading = false,
  setLoading,
  page,
  isSelectedAll = false,
  ignoreIds = "",
  deSelectAllCandidate,
  callback,
  type = "",
}) => {
  const { clientUserAllPermissions } = useSelector((state) => state.session);
  const dispatch = useDispatch();

  // Cleanup when component unmounts or changes
  useEffect(() => {
    return () => {
      dispatch(toggleMarkAsUnsuitableReasonModal(false));
    };
  }, [dispatch]);

  const handleButtonClick = useCallback(() => {
    if (selectedCandidate.some((candidate) => candidate !== "")) {
      dispatch(toggleMarkAsUnsuitableReasonModal(true));
    } else {
      const message =
        type === "invited"
          ? toastMessageText.selectregisteredCandidate
          : toastMessageText.noCandidateSelected;
      showCommonToast(message, { id: "no-candidate-selected" });
    }
  }, [selectedCandidate, dispatch, type]);

  // Render nothing if no permission to mark candidates
  // if (clientUserAllPermissions === "" || !clientUserAllPermissions.is_allow_to_marking_candidate) {
  //   return null;
  // }

  // Don't render button if type is "candidate_detail"
  if (type === "candidate_detail") {
    return null;
  }

  return null;
};

export default MarkAsUnsuitableButton;
